// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navigation_Navigation__6Qn4R .Navigation_navigationLinks__dyyQn {
  background-color: inherit;
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100vw;
}`, "",{"version":3,"sources":["webpack://./src/views/Navigation/Navigation.module.scss"],"names":[],"mappings":"AAGE;EACE,yBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;AAFJ","sourcesContent":["@import 'src/assets/globalStyleElements.module';\n\n.Navigation {\n  .navigationLinks {\n    background-color: inherit;\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    width: 100vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Navigation": `Navigation_Navigation__6Qn4R`,
	"navigationLinks": `Navigation_navigationLinks__dyyQn`
};
export default ___CSS_LOADER_EXPORT___;
